import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { DashboardPage } from '../pages/DashboardPage';

/**
 * `/` and `/dashboard`: the dashboard for whoever may see it. Everyone else
 * (a new colleague whose role has no Dashboard in the sidebar) goes straight
 * to the daily summary instead of an empty dashboard — or to their tasks when
 * the role has no daily summary either.
 */
export function DashboardRoute() {
  const { can, isLoading } = usePermissions();
  if (isLoading) return <div className="p-8 text-gray-500">Se încarcă...</div>;
  if (can('dashboard', 'canView')) return <DashboardPage />;
  return <Navigate to={can('dailySummary', 'canView') ? '/daily-summary' : '/tasks'} replace />;
}
